// extracted by mini-css-extract-plugin
module.exports = {"RatingItem":"RatingItem_RatingItem__3yrrQ","isFull":"RatingItem_isFull__2khn9","isEmpty":"RatingItem_isEmpty__2jUEb"};